import { CoordinatesProps } from '@/ui/components/Distance/Distance'
import { useEffect, useEffectEvent, useState } from 'react'

const toRad = (value: number) => (value * Math.PI) / 180

const calculateDistance = (
  loc1: CoordinatesProps,
  loc2: CoordinatesProps
): number => {
  const lat1 = loc1.latitude
  const lon1 = loc1.longitude
  const lat2 = loc2.latitude
  const lon2 = loc2.longitude

  const R = 6371 // Radius of the Earth in kilometers
  const dLat = toRad(lat2 - lat1)
  const dLon = toRad(lon2 - lon1)
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRad(lat1)) *
      Math.cos(toRad(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2)
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
  const distance = R * c

  return distance // Distance in kilometers
}

const useDistance = (loc1: CoordinatesProps, loc2: CoordinatesProps) => {
  const [distance, setDistance] = useState<number | null>(null)

  const onSetDistance = useEffectEvent((dist: number) => {
    setDistance(dist)
  })

  useEffect(() => {
    if (loc1 && loc2) {
      const dist = calculateDistance(loc1, loc2)
      onSetDistance(dist)
    }
  }, [loc1, loc2])

  return distance
}

export default useDistance
export { calculateDistance }
